export const LOGO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_menagroupfx-preview/artifacts/hp3x1iz6_MENAGroupFX.webp";

export const IMAGES = {
  heroCity:
    "https://images.unsplash.com/photo-1514565131-fce0801e5785?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  skyline:
    "https://images.unsplash.com/photo-1518235506717-e1ed3306a89b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  tradingData:
    "https://images.unsplash.com/photo-1651341050677-24dba59ce0fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  partnership:
    "https://images.pexels.com/photos/8112186/pexels-photo-8112186.jpeg?auto=compress&cs=tinysrgb&w=1400",
  gold:
    "https://images.unsplash.com/photo-1610375461369-d613b564f4c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  education:
    "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  monitors:
    "https://images.pexels.com/photos/5833747/pexels-photo-5833747.jpeg?auto=compress&cs=tinysrgb&w=1400",
};

export const NAV = [
  {
    label: "Markets",
    to: "/markets",
    columns: [
      {
        title: "Markets",
        links: [
          { label: "Forex", to: "/markets/forex", desc: "Major, minor & exotic currency pairs" },
          { label: "Commodities", to: "/markets/commodities", desc: "Gold, silver and energy products" },
          { label: "Indices", to: "/markets/indices", desc: "Major global equity indices" },
          { label: "Shares", to: "/markets/shares", desc: "International company instruments" },
        ],
      },
    ],
  },
  {
    label: "Trading",
    to: "/trading-platforms",
    columns: [
      {
        title: "Trading",
        links: [
          { label: "Trading Platforms", to: "/trading-platforms", desc: "MT5, MT4, Web & Mobile" },
          { label: "Account Solutions", to: "/account-solutions", desc: "Compare account structures" },
          { label: "How It Works", to: "/#how-it-works", desc: "Get started in three steps" },
        ],
      },
    ],
  },
  {
    label: "Insights",
    to: "/market-analysis",
    columns: [
      {
        title: "Insights",
        links: [
          { label: "Market Analysis", to: "/market-analysis", desc: "News, technical & fundamental" },
          { label: "Economic Calendar", to: "/economic-calendar", desc: "Key scheduled events" },
          { label: "Education", to: "/education", desc: "Build your market knowledge" },
        ],
      },
    ],
  },
  {
    label: "Partners",
    to: "/partners",
    columns: [
      {
        title: "Partners",
        links: [
          { label: "Our Broker Partners", to: "/broker-partners", desc: "Explore brokerage solutions" },
          { label: "Become a Partner", to: "/become-a-partner", desc: "Apply to our IB program" },
          { label: "IB Program", to: "/partners", desc: "Commercial opportunities" },
        ],
      },
    ],
  },
  { label: "About", to: "/about-us" },
  { label: "Contact", to: "/contact" },
];

export const CONTACT_INTERESTS = [
  "Opening a Trading Account",
  "Broker Information",
  "Existing Client Support",
  "Partnership / IB Program",
  "Marketing Partnership",
  "Complaint",
  "General Enquiry",
  "Other",
];
